<template>
  <div>
    <div class="c-debug-bar" v-if="visible">
      <button @click="toggle">Hide</button>
      <ol v-if="apiErrors">
        <li v-for="error in apiErrors">
          <pre>{{error.file}}:{{error.line}}</pre>
          <br>
          {{error.no}}: {{error.message}}
          <hr>
        </li>
      </ol>
    </div>
    <div v-else class="c-debug-bar--hidden">
      <button v-if="apiErrors.length" @click="toggle">
        Debug
        <span v-if="apiErrors.length">({{apiErrors.length}} errors)</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'debug-bar',

  data() {
    return {
      visible: false,
    };
  },

  methods: {
    toggle() {
      this.visible = !this.visible;
    },
  },

  computed: {
    apiErrors() {
      return this.$store.state.apiErrors;
    },
  },
};
</script>

<style lang="scss">
.c-debug-bar {
  background: rgb(235, 146, 146);
  border: 1px solid rgb(201, 0, 0);
  position: fixed;
  right: 1em;
  bottom: 1em;
  left: 1em;
  max-height: 100px;
  opacity: 0.5;
  overflow: hidden;
  z-index: 99999;

  padding: 1em;

  color: #000;

  &:hover {
    top: 1em;
    overflow: scroll;
    opacity: 1;
    height: auto;
    max-height: none;
  }

  ol,
  li {
    color: #000;
  }
}
.c-debug-bar--hidden {
  opacity: 0.5;
  position: fixed;
  top: 0;
  left: 45%;
  z-index: 99999;
}
</style>
